import React from 'react';
import { Outlet } from 'react-router-dom';
import V3Sidebar from './V3Sidebar';
import V3Header from './V3Header';
import { PageHeaderProvider } from '../../../contexts/PageHeaderContext';
import { NavigationProvider } from '../../../contexts/NavigationContext';
import { JunoProvider } from '../../../contexts/JunoContext';
import JunoOrb from '../juno/JunoOrb';
import { Toaster } from 'sonner';

const V3LayoutInner: React.FC = () => {
  return (
    <div className="flex h-screen bg-gray-50 print:block print:h-auto print:bg-white">
      {/* Sidebar */}
      <div className="print:hidden">
        <V3Sidebar />
      </div>
      
      {/* Main Content Area */}
      <div className="flex-1 flex flex-col overflow-hidden print:block print:overflow-visible">
        {/* Header */}
        <div className="print:hidden">
          <V3Header />
        </div>
        
        {/* Page Content */}
        <main className="flex-1 overflow-y-auto bg-white print:overflow-visible">
          <Outlet />
        </main>
      </div>
      
      {/* Juno Orb - Persistent across all V3 routes */}
      <div className="print:hidden">
        <JunoOrb />
      </div>
    </div>
  );
};

const V3Layout: React.FC = () => {
  return (
    <JunoProvider>
      <PageHeaderProvider>
        <NavigationProvider>
          <V3LayoutInner />
          <div className="print:hidden">
            <Toaster />
          </div>
        </NavigationProvider>
      </PageHeaderProvider>
    </JunoProvider>
  );
};

export default V3Layout;
